// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_pl-5";
export var filledCircle = "_pl-4";
export var historyEntry = "_pl-3";
export var messageSideLeft = "_pl-1";
export var messageSideRight = "_pl-2";
export var orderTrackingCarouselWrapper = "_pl-6";
export var orderTrackingInfoContainer = "_pl-0";